
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 15 20","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.25","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M8.618 3.125v6.25m-4.375-6.25L.803 8.857a1.25 1.25 0 00-.098 1.084l1.305 3.476a1.25 1.25 0 001.365.796L14.243 12.5V9.375H3.618m.625-6.25h10v-2.5h-10z"}}),_c('path',{attrs:{"d":"M13.796 9.375l.447-3.125V3.125M8.618 13.389v5.986h3.75l.962-6.731M7.368.625v2.5m3.125-2.5v2.5M2.368 6.25l3.125-.625m6.875 0l1.794 1.196"}})])])
          )
        }
      }
    